export const SlackOAuthClientKind = {
  Web: "web",
  Desktop: "desktop",
  Ios: "ios",
  Unknown: "unknown",
} as const;

export type SlackOAuthClientKind = (typeof SlackOAuthClientKind)[keyof typeof SlackOAuthClientKind];

const SLACK_OAUTH_STATE_CLIENT_KIND_SEPARATOR = ".";

export const getSlackOAuthClientKindFromState = (state: string | null): SlackOAuthClientKind => {
  if (!state) {
    return SlackOAuthClientKind.Unknown;
  }

  const [clientKind] = state.split(SLACK_OAUTH_STATE_CLIENT_KIND_SEPARATOR);

  if (clientKind === SlackOAuthClientKind.Web) {
    return SlackOAuthClientKind.Web;
  }

  if (clientKind === SlackOAuthClientKind.Desktop) {
    return SlackOAuthClientKind.Desktop;
  }

  if (clientKind === SlackOAuthClientKind.Ios) {
    return SlackOAuthClientKind.Ios;
  }

  return SlackOAuthClientKind.Unknown;
};
